module.exports = __webpack_public_path__ + "img/transaction.dc8d3057.svg";